<template>
  <svg
    v-if="categoryId === 1"
    :width="width || 19"
    :height="height || 19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.48938 18.3544V6.89563H5.02063V18.3544H0.48938ZM7.23438 18.3544V0.64563H11.7656V18.3544H7.23438ZM13.9531 18.3544V8.97938H18.4844V18.3544H13.9531Z"
      fill="#0A0A0A"
    />
  </svg>

  <svg
    v-else-if="categoryId === 2"
    :width="width || 15"
    :height="height || 19"
    viewBox="0 0 15 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.20813 18.875V0.125H10.2606L14.7919 4.65625V18.875H0.20813ZM7.42188 16.0106H8.3075V14.9688H10.4688V10.88H6.14563V8.5625H10.4688V7.67688H8.3075V6.63562H7.42188V7.67688H5.26063V11.7656H9.58313V14.0831H5.26063V14.9688H7.42188V16.0106ZM9.89563 4.65625H13.5419L9.89563 1.01062V4.65625Z"
      fill="#0A0A0A"
    />
  </svg>

  <svg
    v-else-if="categoryId === 3"
    :width="width || 19"
    :height="height || 19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.296875 18.3544V17.4688H11.755V18.3544H0.296875ZM6.46875 12.5206L1.33875 7.39063L2.6925 5.98438L7.875 11.1144L6.46875 12.5206ZM12.1981 6.79188L7.0675 1.60938L8.47375 0.255005L13.6044 5.38563L12.1981 6.79188ZM17.5625 17.1044L4.59375 4.13563L5.21875 3.51063L18.1875 16.4794L17.5625 17.1044Z"
      fill="#0A0A0A"
    />
  </svg>

  <svg
    v-else-if="categoryId === 4"
    :width="width || 21"
    :height="height || 19"
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9169 0.0831299V9.38C20.344 8.92875 19.7058 8.58167 19.0025 8.33875C18.2996 8.09542 17.5835 7.97375 16.8544 7.97375C16.4202 7.97375 15.9948 8.01292 15.5781 8.09126C15.1615 8.16917 14.7535 8.28625 14.3544 8.4425V6.95813L8.85938 3.07813V0.0831299H20.9169ZM16.0731 4.875H17.5313V3.41688H16.0731V4.875ZM16.8544 18.8331C15.7256 18.8331 14.7663 18.4383 13.9763 17.6488C13.1867 16.8588 12.7919 15.8994 12.7919 14.7706C12.7919 13.6423 13.1867 12.6788 13.9763 11.88C14.7663 11.0817 15.7256 10.6825 16.8544 10.6825C17.9827 10.6825 18.9419 11.0817 19.7319 11.88C20.5219 12.6788 20.9169 13.6423 20.9169 14.7706C20.9169 15.8994 20.5219 16.8588 19.7319 17.6488C18.9419 18.4383 17.9827 18.8331 16.8544 18.8331ZM16.4894 17.8438H17.245V15.1356H19.9269V14.4063H17.245V11.7238H16.4894V14.4063H13.8075V15.1356H16.4894V17.8438ZM0.0831299 16.75V7.97375L6.255 3.57313L12.4269 7.97375V9.58875C11.6806 10.2483 11.0992 11.0252 10.6825 11.9194C10.2658 12.8135 10.0575 13.764 10.0575 14.7706C10.0575 15.1006 10.0879 15.4306 10.1488 15.7606C10.2092 16.0902 10.2915 16.42 10.3956 16.75H8.1825V11.62H4.32813V16.75H0.0831299Z"
      fill="#0A0A0A"
    />
  </svg>

  <svg
    v-else-if="categoryId === 5"
    :width="width || 19"
    :height="height || 19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.64563 16.245V15.3594H5.90625V16.245H0.64563ZM0.64563 3.64063V2.755H10.125V3.64063H0.64563ZM8.875 18.3544V13.25H9.76063V15.3594H18.3544V16.245H9.76063V18.3544H8.875ZM5.02063 12.0519V9.9425H0.64563V9.0575H5.02063V6.94813H5.90625V12.0519H5.02063ZM8.875 9.9425V9.0575H18.3544V9.9425H8.875ZM13.0938 5.72375V0.64563H13.9794V2.755H18.3544V3.64063H13.9794V5.72375H13.0938Z"
      fill="#0A0A0A"
    />
  </svg>

  <svg
    v-else-if="categoryId === 6"
    :width="width || 19"
    :height="height || 20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3231 19.8488C16.219 19.8488 16.1233 19.8315 16.0363 19.7969C15.9496 19.7623 15.8629 19.7102 15.7763 19.6406L10.2031 14.0675V13.1825L12.1044 11.255H12.9894L18.5888 16.8544C18.6579 16.9235 18.7056 17.0058 18.7319 17.1013C18.7577 17.1971 18.7706 17.2971 18.7706 17.4013C18.7706 17.5054 18.7577 17.6008 18.7319 17.6875C18.7056 17.7742 18.6492 17.861 18.5625 17.9481L16.8438 19.6406C16.7742 19.7102 16.696 19.7623 16.6094 19.7969C16.5227 19.8315 16.4273 19.8488 16.3231 19.8488ZM16.3231 18.9375L17.8856 17.375L12.5988 12.0888L11.0363 13.6513L16.3231 18.9375ZM2.65125 19.8488C2.54709 19.8488 2.45146 19.8315 2.36438 19.7969C2.27771 19.7623 2.19959 19.7102 2.13 19.6406L0.38563 17.9219C0.316046 17.8352 0.263963 17.7483 0.22938 17.6613C0.19438 17.5746 0.17688 17.4792 0.17688 17.375C0.17688 17.2708 0.19438 17.1754 0.22938 17.0888C0.263963 17.0017 0.316046 16.9148 0.38563 16.8281L5.85438 11.3594H8.04188L8.875 10.5263L4.37 6.02063H2.88563L0.22938 3.36438L2.33875 1.255L4.995 3.91125V5.39563L9.5 9.90125L12.755 6.64563L10.6456 4.53625L11.8175 3.36438H9.44813L9.10938 3.02625L11.9481 0.1875L12.2863 0.5V2.89563L13.4581 1.72375L17.8075 6.02063C18.0504 6.24646 18.2327 6.51125 18.3544 6.815C18.4756 7.11875 18.5363 7.44438 18.5363 7.79188C18.5363 8.03479 18.5058 8.26479 18.445 8.48188C18.3846 8.69896 18.2935 8.91167 18.1719 9.12L16.0363 6.98438L14.5519 8.46875L13.3544 7.27063L8.64063 11.9844V14.1981L3.19813 19.6406C3.11105 19.7102 3.02417 19.7623 2.9375 19.7969C2.85084 19.8315 2.75542 19.8488 2.65125 19.8488ZM2.65125 18.9375L8.01563 13.5469L6.45313 11.9844L1.08875 17.3488L2.65125 18.9375Z"
      fill="#0A0A0A"
    />
  </svg>

  <svg
    v-else-if="categoryId === 7"
    :width="width || 19"
    :height="height || 18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.26562 17.875V16.9894H16.9481V8.55187C16.9481 7.5452 16.7483 6.59479 16.3488 5.70062C15.9496 4.80645 15.4115 4.02083 14.7344 3.34375C14.0573 2.66666 13.2673 2.12854 12.3644 1.72937C11.4619 1.32979 10.5071 1.13 9.5 1.13C8.49292 1.13 7.53813 1.32979 6.63562 1.72937C5.73271 2.12854 4.94271 2.66666 4.26562 3.34375C3.58854 4.02083 3.05042 4.80645 2.65125 5.70062C2.25167 6.59479 2.05188 7.5452 2.05188 8.55187V14.7762H0.125V9.64562H1.16687L1.1925 8.3175C1.21 7.18916 1.44875 6.13458 1.90875 5.15375C2.36875 4.17291 2.97646 3.31791 3.73187 2.58875C4.48688 1.85958 5.35917 1.28666 6.34875 0.869995C7.33833 0.453328 8.38875 0.244995 9.5 0.244995C10.6112 0.244995 11.6658 0.448954 12.6637 0.85687C13.6621 1.26479 14.5346 1.83333 15.2812 2.5625C16.0279 3.29166 16.6269 4.14666 17.0781 5.1275C17.5294 6.10833 17.7725 7.17166 17.8075 8.3175L17.8331 9.64562H18.875V14.7762H17.8331V17.875H9.26562ZM6.76562 10.6612C6.57479 10.6612 6.40979 10.5875 6.27063 10.44C6.13188 10.2925 6.0625 10.1233 6.0625 9.9325C6.0625 9.74125 6.13188 9.57625 6.27063 9.4375C6.40979 9.29875 6.57479 9.22937 6.76562 9.22937C6.97396 9.22937 7.1475 9.29875 7.28625 9.4375C7.42542 9.57625 7.495 9.74125 7.495 9.9325C7.495 10.1233 7.42542 10.2925 7.28625 10.44C7.1475 10.5875 6.97396 10.6612 6.76562 10.6612ZM12.2344 10.6612C12.0435 10.6612 11.8742 10.5875 11.7262 10.44C11.5788 10.2925 11.505 10.1233 11.505 9.9325C11.505 9.74125 11.5788 9.57625 11.7262 9.4375C11.8742 9.29875 12.0435 9.22937 12.2344 9.22937C12.4252 9.22937 12.5902 9.29875 12.7294 9.4375C12.8681 9.57625 12.9375 9.74125 12.9375 9.9325C12.9375 10.1233 12.8681 10.2925 12.7294 10.44C12.5902 10.5875 12.4252 10.6612 12.2344 10.6612ZM4.005 8.995C3.93583 8.09208 4.0575 7.26729 4.37 6.52062C4.6825 5.77437 5.10333 5.1452 5.6325 4.63312C6.16208 4.12062 6.77417 3.72562 7.46875 3.44812C8.16333 3.1702 8.85771 3.03125 9.55188 3.03125C10.941 3.03125 12.1346 3.47395 13.1325 4.35937C14.1308 5.24479 14.7342 6.34729 14.9425 7.66687C13.5017 7.64937 12.2127 7.26291 11.0756 6.5075C9.93854 5.7525 9.06604 4.76729 8.45813 3.55187C8.21521 4.78479 7.69438 5.88291 6.89563 6.84625C6.09729 7.81 5.13375 8.52625 4.005 8.995Z"
      fill="#0A0A0A"
    />
  </svg>
</template>

<script>
export default {
  name: "ApplicationFooter",
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      required: false,
      default: null,
    },
    height: {
      type: Number,
      required: false,
      default: null,
    },
  },
};
</script>
